import { isNil } from 'lodash-es'

/**
 * Calculates the client demand for a shift.
 * Client demand is the number of workers required minus the reported demand buffer.
 * If reported_demand_buffer is null or undefined, returns null.
 */
export const calculateClientDemand = (shift: {
  workers_required?: number
  reported_demand_buffer?: number | null
}): number | null => {
  const workersRequired = shift.workers_required || 0
  const reportedDemandBuffer = shift.reported_demand_buffer

  if (isNil(reportedDemandBuffer)) {
    return null
  }

  return workersRequired - reportedDemandBuffer
}
